import { render } from "./NotFound.vue?vue&type=template&id=87bfe42a"
const script = {}

import exportComponent from "E:\\Work\\bigSis_vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__